/**
 * Reproduces the byte Godot stores for a Polygon2D fill colour (`scene/2d/polygon_2d.cpp:307-318`):
 * the mesh upload (`scene/2d/polygon_2d.cpp:395`) casts it to `uint8_t`, truncating
 * (`servers/rendering/rendering_server.cpp:713-716`). The shader reads that byte, so the loss
 * precedes shading, lighting and blending.
 */
import { unitByte } from '../../../godot/rendering/unitByte';
/**
 * `unitByte` on all four channels. Never apply it to the inherited tint:
 * Polygon2D passes `Color(1, 1, 1)` as its own draw modulate (`scene/2d/polygon_2d.cpp:401`), so
 * the tint is a separate float multiply. Only Polygon2D fills pass this cast
 * (`vertexColorQuantize.md`).
 */
export function quantizeVertexColor(color) {
    return {
        r: unitByte(color.r),
        g: unitByte(color.g),
        b: unitByte(color.b),
        a: unitByte(color.a),
    };
}
//# sourceMappingURL=vertexColorQuantize.js.map